import "./hotpicks.css";

const Hotpicks = ({ data }) => {
  return (
    <div className="hotpicks">
      <div className="hpProductImageContainer">
        <img
          src={data.competition_image_url}
          alt={data.competition_prize_name}
          className="hpProductImage"
        />
      </div>
      <div className="hpDescriptionContainer">
        <div className="hpDescription">
          <div className="hpDescriptionText">{data.competition_prize_name}</div>
          <div className="hpTicketsSold">
            {" "}
            {data.competition_tickets_sold} Tickets Sold
          </div>
          <div className="hpPrice"> £{data.competition_cash_value}</div>
        </div>
      </div>
    </div>
  );
};

export default Hotpicks;
